import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
var _ref = {
  name: "1ocybxp",
  styles: "gap:75px;margin:auto 0;"
};
var _ref2 = {
  name: "178nes6",
  styles: "flex-grow:1;gap:32px;margin:auto 0;"
};
var _ref3 = {
  name: "jv3ngs",
  styles: "width:100%;gap:24px;"
};
export var statsButtons = appearance => /*#__PURE__*/css("display:flex;flex-direction:", appearance === 'vertical' ? 'column' : 'row', ";align-items:center;", appearance === 'horizontal' && _ref, " ", appearance === 'tablet' && _ref2, " ", appearance === 'vertical' && _ref3);
var _ref4 = {
  name: "1fmaocf",
  styles: "gap:32px;"
};
var _ref5 = {
  name: "u8tkq2",
  styles: "flex-grow:1;gap:24px;"
};
var _ref6 = {
  name: "8atqhb",
  styles: "width:100%;"
};
export var stats = appearance => /*#__PURE__*/css("display:flex;flex-direction:row;align-items:flex-start;justify-content:space-between;", appearance === 'horizontal' && _ref4, " ", appearance === 'tablet' && _ref5, " ", appearance === 'vertical' && _ref6);
export var stat = {
  name: "171onha",
  styles: "display:flex;align-items:center;gap:4px;"
};
var _ref7 = {
  name: "ql2sl9",
  styles: "max-width:62px;"
};
export var statColumn = appearance => /*#__PURE__*/css("display:flex;flex-direction:column;min-width:46px;align-items:center;", appearance === 'tablet' && _ref7);
export var statValue = /*#__PURE__*/css(designTokenFonts.displaySmall, " color:", colors.neutral.heavy.default, ";");
export var statDescription = /*#__PURE__*/css(designTokenFonts.mini, " color:", colors.neutral.heavy.default, ";");
var _ref8 = {
  name: "1t2w4ts",
  styles: "width:100%;height:94px;justify-content:end;"
};
var _ref9 = {
  name: "l01k19",
  styles: "min-width:272px;"
};
var _ref10 = {
  name: "1o9g0p",
  styles: "width:180px;"
};
export var buttons = appearance => /*#__PURE__*/css("display:flex;flex-direction:column;align-items:flex-start;gap:8px;z-index:1;", appearance === 'vertical' && _ref8, " ", appearance === 'horizontal' && _ref9, " ", appearance === 'tablet' && _ref10);
var _ref11 = {
  name: "i06y6t",
  styles: "min-width:180px;"
};
var _ref12 = {
  name: "1q4l94b",
  styles: "min-width:175px;"
};
export var button = appearance => /*#__PURE__*/css(designTokenFonts.bodyBold, " width:100%;max-height:44px;", appearance === 'tablet' && _ref11, " .button{", designTokenFonts.bodyBold, " width:100%;", appearance === 'tablet' && _ref12, "}");